// extracted by mini-css-extract-plugin
export default {"imgdiv":"_38a5379062 e2ab713f8e","img":"_0c0b1a005d _1a4647d1ef"};